import { render, staticRenderFns } from "./ReviewRequestProRecordDetails.vue?vue&type=template&id=718fbd6a&scoped=true&"
import script from "./ReviewRequestProRecordDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewRequestProRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequestProRecordDetails.vue?vue&type=style&index=0&id=718fbd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718fbd6a",
  null
  
)

export default component.exports